import React from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";

const formatUsd = (value) => `USD ${parseFloat(value || 0).toFixed(2)}`;

const StatCard = ({ label, value, icon, tone }) => (
  <article className={`event-my-earnings-stat is-${tone}`}>
    <div className="event-my-earnings-stat-copy">
      <span className="event-my-earnings-stat-label">{label}</span>
      <strong className="event-my-earnings-stat-value">{value}</strong>
    </div>
    <span className="event-my-earnings-stat-icon" aria-hidden="true">
      <i className={`bi ${icon}`}></i>
    </span>
  </article>
);

const EarningDetailsCardSection = ({
  isError,
  isLoading,
  details,
  dataType = "ticket",
  orderDetails,
  promoterDetails,
}) => {
  const ticketStats = [
    {
      label: "Total Ticket Type",
      value: details?.totalTickets || 0,
      icon: "bi-ticket-perforated",
      tone: "rose",
    },
    {
      label: "Total Tickets Purchase",
      value: Math.round(details?.totalTicketsPurchase || 0),
      icon: "bi-box-arrow-up",
      tone: "orange",
    },
    {
      label: "Total Earnings",
      value: formatUsd(details?.totalEarnings ?? details?.totalCommission),
      icon: "bi-cash-stack",
      tone: "violet",
    },
  ];

  const orderStats = [
    {
      label: "Total Orders",
      value: orderDetails?.totalOrders || 0,
      icon: "bi-bag",
      tone: "rose",
    },
    {
      label: "Total Sale",
      value: formatUsd(orderDetails?.totalSale),
      icon: "bi-box-arrow-up",
      tone: "orange",
    },
    {
      label: "Total Earnings",
      value: formatUsd(orderDetails?.totalEarnings),
      icon: "bi-cash-stack",
      tone: "violet",
    },
  ];

  const promoterStats = [
    {
      label: "Total Promoters",
      value: promoterDetails?.totalPromoters || 0,
      icon: "bi-people",
      tone: "rose",
    },
    {
      label: "Total Promoted Orders",
      value: promoterDetails?.totalPromotedOrders || 0,
      icon: "bi-box-arrow-up",
      tone: "orange",
    },
    {
      label: "Total Commission",
      value: formatUsd(promoterDetails?.totalEarnings),
      icon: "bi-cash-stack",
      tone: "violet",
    },
  ];

  const stats =
    dataType === "order"
      ? orderStats
      : dataType === "promoter"
      ? promoterStats
      : ticketStats;

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-earning-detail-stats">
        {stats.map((stat) => (
          <StatCard key={stat.label} {...stat} />
        ))}
      </div>
    </MainComponentWrapper>
  );
};

export default EarningDetailsCardSection;
